import BaseService from 'services/BaseService';

async function handleResponse(response, signOut) {

  switch (response.status) {
    case 200:
      return response.json();
    case 400:
      return response.json();
    default:
      //await signOut();
      throw new Error(`Unhandled status code: ${response.status}`);
  }
}


export async function Update(object,id,user) {
  try {
    const response = await BaseService.patch(`/user/admin/${id}`, object)
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}


export async function apiGetAllAdmins(user) {
  const response = await BaseService.get('/user/admin/all')
  return response.data
}

export async function apiGetAllClients() {
  try {
    const response = await BaseService.get('/client/all')
    return response.data
  } catch (error) {
    console.error('apiGetAllClients error:', error)
    throw error
  }
}

export async function createClient(object) {
  try {
    const response = await BaseService.post('/client', {
      name: object.name,
    })

    return response.data
  } catch (error) {
    console.error('createClient error:', error)
    throw error
  }
}

export async function createadmin(object, user,) {
  const response = await BaseService.post('/user/admin', {
    phoneNumber: object.phoneNumber,
    firstName: object.firstName,
    lastName: object.lastName,
    email: object.email,
  })
  return response.data
}


export async function deleteAdmin(id) {
  try {
    const response = await BaseService.delete(`/user/admin/${id}`)
    return response.data
  } catch (error) {
    console.error('deleteAdmin error:', error)
    throw error
  }
}
